import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { uploadInfluencerVideoSuccess } from '../../actions/InfluencerCampaignActions/uploadInfluencerVideoActions';
import { uploadInfluencerVideoFailure } from '../../actions/InfluencerCampaignActions/uploadInfluencerVideoActions';

function* uploadInfluencerVideo({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.uploadInfluencerVideo,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("UPLOAD_INFLUENCER_VIDEO_SUCCESS status :", response.data.status);
        console.log("UPLOAD_INFLUENCER_VIDEO_SUCCESS data :", response.data.response);
        console.log("UPLOAD_INFLUENCER_VIDEO_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            uploadInfluencerVideoSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("UPLOAD_INFLUENCER_VIDEO_FAILURE status :", error?.response?.status);
        console.log("UPLOAD_INFLUENCER_VIDEO_FAILURE data:", error?.response?.data);
        console.log("UPLOAD_INFLUENCER_VIDEO_FAILURE error :", error);
        console.log('====================================');
        yield put(uploadInfluencerVideoFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* uploadInfluencerVideoSaga() {
    yield takeLatest(actionTypes.UPLOAD_INFLUENCER_VIDEO_REQUEST, uploadInfluencerVideo);
}

export default uploadInfluencerVideoSaga;
